import { getActiveCompanyConfig } from "domain/company/companyConfig";

import { User } from "firebase/auth";


export function isAuthorized(user: User | null): boolean {
  if (!user || !user.email) {
    return false;
  }

  const { allowedEmailDomainSubstrings, whitelist } =
    getActiveCompanyConfig().authorization;

  return (
    allowedEmailDomainSubstrings.some((domain) =>
      user.email!.includes(domain)
    ) || whitelist.includes(user.email)
  );
}
